import { ButtonBase } from '@mui/material';
import { useNavigate } from 'react-router';

const TokenLink = () => {
  const navigate = useNavigate();
  return (
    <>
      Don’t have one yet? Create a new token quickly and easily{' '}
      <ButtonBase
        sx={{ color: 'primary.main', textDecoration: 'none', fontSize: 16, mb: 0.5 }}
        onClick={() => navigate('/profile')}
      >
        here.
      </ButtonBase>
    </>
  );
};

export default TokenLink;
